export default "__VITE_ASSET__42411274__"